const PwnageCart = {
  updateCart: function () {
    fetch(window.Shopify.routes.root + "cart.js", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        const maybePluralize = (count, noun, suffix = "s") =>
          `${count} ${noun}${count !== 1 ? suffix : ""}`
        document.getElementById("cart-menu").innerHTML =
          maybePluralize(data.item_count, "Item") +
          " (" +
          Shopify.formatMoney(
            data.total_price,
            ""
          ) +
          ")"
      })
      .catch((error) => {
        console.error("Error:", error)
      })
  },
}
